export default (
  <svg width="100%" height="100%" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Antenna */}
    <circle cx="50" cy="8" r="4" fill="#3D5A80" />
    <rect x="48" y="10" width="4" height="12" fill="#3D5A80" />

    {/* Head */}
    <rect x="20" y="22" width="60" height="30" rx="6" fill="#3D5A80" />
    {/* Eyes */}
    <circle cx="38" cy="37" r="7" fill="white" />
    <circle cx="62" cy="37" r="7" fill="white" />

    {/* Body */}
    <rect x="15" y="55" width="70" height="28" rx="4" fill="#3D5A80" />
    {/* Button on body */}
    <circle cx="75" cy="64" r="5" fill="white" />

    {/* Paper tray / mouth area */}
    <rect x="25" y="70" width="50" height="12" rx="4" fill="white" />
  </svg>
);
